enum BACKEND_ERROR_CODES {
  KYC_NOT_APPROVED = 'kyc_not_approved',
  INVALID_GOOGLE_TOKEN = 'invalid_google_token',
  MFA_ALREADY_DISABLED = 'mfa_already_disable',
  USER_NOT_FOUND = 'user_not_found',
  OAUTH_NOT_ACTIVE = 'oauth_not_active',
  FAILED_TO_ENROL_HYPERVERGE = 'failed_to_enrol_data_from_hyperverge',
  S3_ERROR = 's3_error',
  DELETED_ACCOUNT_EXISTS = 'deleted_account_exists',
  HYPERVERGE_ACCOUNT_ENROL_FAILED = 'hyperverge_account_enrol_failed',
}

export { BACKEND_ERROR_CODES };
